import CryptoJS from "crypto-js";
export const useCrypto = {
  encrypt(plainText){
    let key = CryptoJS.enc.Utf8.parse(useRuntimeConfig().public.AES_KEY);
    let iv = CryptoJS.enc.Utf8.parse(useRuntimeConfig().public.AES_IV);
    let encryptedData = CryptoJS.AES.encrypt(plainText, key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    });
    return encryptedData.toString();
  },
  encBase64(plainText){
    let text = CryptoJS.enc.Utf8.parse(plainText);
    return CryptoJS.enc.Base64.stringify(text);
  }
}
